import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// Estilos del componente
const useStyles = makeStyles(() => ({
    messageError: {
        fontSize: 14,
        color: '#C00333',
        marginLeft: 10,
    },
}));

/**
 * @desc Compoenente para renderizar un input de manera generica
 * @param {*} param0
 */
const TextOtpBase = React.forwardRef((
    {
        inputsNum, onChangeArray,
        field: {
            name, type = 'number',
        }, form: { touched, errors, setFieldValue }, ...props
    },
) => {
    const classes = useStyles();
    const hasError = touched[name] && Boolean(errors[name]);
    const otpArray = new Array(inputsNum).fill(''); // Array para iterar el input
    const gridNumber = 12 / otpArray.length; // sacamos el numero del grid segun el array que llegue
    const otpValue = new Array(inputsNum); // Variable para setear array dinamico
    const inputRefs = useRef([]); // Referencia del input para poner foco
    let eventInput = null; // Maneja la tecla que se ha oprimido para controlar retoceso del input

    useEffect(() => {
        inputRefs.current = inputRefs.current.slice(0, otpArray.length);
    }, []);

    /**
     * @name handleOnChange
     * @desc función que almacena el dato ingresado y cambia el focus del input
     * @param event
     * @param index
     */
    const handleOnChange = (event, index) => {
        if (eventInput !== 8) {
            // Se testea el valor ingresado para guardar en el array
            const fieldValue = (/^[0-9]{1,1}$/.test(+event.target.value)) ? event.target.value : '';
            otpValue[index] = fieldValue;
            onChangeArray({ index, code: fieldValue });

            // Evaluo si el ultimo item se completo para guardar arreglo en string y enviar al padre
            if (otpValue[inputsNum - 1] !== undefined || otpValue[inputsNum - 1] !== undefined) {
                // Formateo el array y lo paso en string
                const stringArray = otpValue.toString();
                const finalValue = stringArray.replace(/,/g, '');
                setFieldValue(name, finalValue);
            } else {
                // Se pone el focus en el siguiente elemento
                inputRefs.current[index + 1].focus();
            }
        }
    };

    /**
     * @name handleKeyDown
     * @desc funcion para eliminar el dato del input
     * @param event
     * @param index
     */
    const handleKeyDown = (event, index) => {
        eventInput = event.keyCode;
        if (event.keyCode === 8 && event.target.value.length === 0) {
            inputRefs.current[index - 1].focus();
            // otpValue[index] = null;
            event.preventDefault();
        }
    };

    /**
     * @name changeFocus
     * @desc funcion que almacena el input que se esta marcando en el omento
     * @param el
     * @param index
     */
    const changeFocus = (el, index) => {
        inputRefs.current[index] = el;
    };

    return (
      <Grid container direction="row" spacing={2}>
        <>
          {otpArray.map((otp, index) => (
            <Grid item xs={gridNumber} md={gridNumber} key={`OTP-${index + 1}`}>
              <TextField
                variant="standard"
                type={type}
                autoComplete="off"
                fullWidth
                margin="dense"
                id={name}
                inputRef={(el) => changeFocus(el, index)}
                name={`${name}-${index}`}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onChange={(e) => handleOnChange(e, index)}
                value={otpValue[index]}
                onInput={(e) => {
                            // eslint-disable-next-line radix
                 e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1);
                        }}
                {...props}
              />
            </Grid>
            ))}
          {Boolean(hasError) && (
            <p className={classes.messageError}>{errors[name]}</p>
            )}
        </>
      </Grid>
    );
});

TextOtpBase.defaultProps = {
    ref: null,
    inputsNum: 6,
};

TextOtpBase.propTypes = {
    field: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        type: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    }).isRequired,
    form: PropTypes.shape({
        touched: PropTypes.shape().isRequired,
        errors: PropTypes.shape().isRequired,
        setFieldValue: PropTypes.func.isRequired,
    }).isRequired,
    ref: PropTypes.func,
    // Funcion para retornar el array y almacenar en padre
    onChangeArray: PropTypes.func.isRequired,
    // Numero de campos a mostrar en el input
    inputsNum: PropTypes.number,
};

export default TextOtpBase;
